import type { UseQueryResult } from '@tanstack/react-query';

import { type TranslationGetter } from '../../types';

class ManagerHelpers {
  public retryQueries(queries: UseQueryResult[]) {
    queries.forEach((query) => query.isError && query.refetch());
  }

  public createEmptyTranslationGetter(): TranslationGetter {
    return () => '';
  }
}

export const managerHelpers = new ManagerHelpers();
